'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useTheme } from 'next-themes';
export enum Theme {
  Light = 'light',
  Dark = 'dark',
}
export function ThemeSwitcher() {
  const $ = _c(3);
  const {
    setTheme
  } = useTheme();
  let t0;
  let t1;
  if ($[0] !== setTheme) {
    t0 = () => {
      setTheme("dark");
    };
    t1 = [setTheme];
    $[0] = setTheme;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}